import React from 'react';

import { Button, Result } from 'antd';
import { FormattedMessage } from 'react-intl';

import { ACCOUNT_CONTACT_EMAIL } from '../../constants';

/** Replaces the organization's screens once its account is cancelled. */
export const AccountCancelled: React.FC = React.memo(() => (
  <Result
    extra={
      <Button href={`mailto:${ACCOUNT_CONTACT_EMAIL}`} type="primary">
        <FormattedMessage id="accountStatus.banner.contact" />
      </Button>
    }
    status="warning"
    subTitle={<FormattedMessage id="accountStatus.cancelled.description" />}
    title={<FormattedMessage id="accountStatus.cancelled.title" />}
  />
));

AccountCancelled.displayName = 'AccountCancelled';
